<template>
  <div class="prose prose-lg max-w-none">
    <p class="text-gray-600 mb-6">Last updated: 17.01.2026</p>

    <p class="text-gray-700 mb-8">
      These Tutor Terms & Conditions ("Terms") govern your participation as a tutor on the Bindle platform.
    </p>

    <p class="text-gray-700 mb-8">
      By ticking the box "I agree to the Tutor Terms & Conditions", you confirm that you have read, understood, and agree to be legally bound by these Terms.
    </p>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">1. About Bindle</h2>
      <p class="text-gray-700 mb-4">
        Bindle Resources Ltd ("Bindle", "we", "us") operates an online education platform that enables tutors to publish educational content and provide tutoring services to students through subscription-based products.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">2. Status of Tutors</h2>
      <p class="text-gray-700 mb-4">
        You engage with Bindle strictly as an independent contractor.
      </p>
      <ul class="list-disc pl-6 text-gray-700 mb-4 space-y-2">
        <li>You are not an employee, worker, agent, partner, or representative of Bindle.</li>
        <li>You are responsible for all taxes and statutory obligations.</li>
        <li>Bindle is not responsible for your conduct or services provided to students.</li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">3. Tutor Content & Intellectual Property</h2>
      <ul class="list-disc pl-6 text-gray-700 mb-4 space-y-2">
        <li>You retain ownership of all intellectual property rights in content you upload ("Tutor Content").</li>
        <li>You grant Bindle a perpetual, worldwide, royalty-free licence to host, display, distribute, modify, and use Tutor Content for platform, operational, AI, and marketing purposes.</li>
        <li>Tutor Content must remain exclusive to Bindle while available on the platform.</li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">4. Video Upload Limits</h2>
      <p class="text-gray-700 mb-4">
        Tutors may upload up to 20 hours of video content free of charge. Additional storage may be charged at £0.0024 per minute.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">5. Subscriptions, Pricing & Payments</h2>
      <ul class="list-disc pl-6 text-gray-700 mb-4 space-y-2">
        <li>Tutors may set subscription prices within boundaries set by Bindle.</li>
        <li>Bindle retains a 15% platform fee; tutors receive 85%.</li>
        <li>Payments are made monthly in arrears and may be adjusted for cancellations or credits.</li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">6. Conduct & Safeguarding</h2>
      <ul class="list-disc pl-6 text-gray-700 mb-4 space-y-2">
        <li>Tutors must act professionally and deliver sessions as scheduled.</li>
        <li>If more than three sessions are missed without valid reason, Bindle may terminate the account.</li>
        <li>Tutors must hold a valid Enhanced DBS certificate (issued within the last 24 months) and provide ID.</li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">7. Non-Solicitation</h2>
      <p class="text-gray-700 mb-4">
        Tutors must not solicit students off-platform during engagement or for 12 months after termination.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">8. AI & Analytics</h2>
      <p class="text-gray-700 mb-4">
        Bindle may analyse Tutor Content and usage data to improve the platform.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">9. Termination</h2>
      <p class="text-gray-700 mb-4">
        Either party may terminate with 30 days' notice. Bindle may terminate immediately for serious breach.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">10. Liability</h2>
      <p class="text-gray-700 mb-4">
        Tutors indemnify Bindle against claims arising from Tutor Content or services.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold text-gray-900 mb-4">11. Governing Law</h2>
      <p class="text-gray-700 mb-4">
        These Terms are governed by the laws of England and Wales.
      </p>
    </section>
  </div>
</template>
